module.exports = __webpack_public_path__ + "static/media/sbahn-echtzeit~hyVQoqdm.7c440c6b.svg";